<div class="invoice-container">
  <h2>Proformas</h2>

  <!-- <div class="actions-section">
    <button mat-raised-button class="create-btn" (click)="createNewProforma()">
      <mat-icon>add</mat-icon>
      Create New Proforma
    </button>
  </div> -->

  <div class="invoice-content">
    <div *ngIf="loading" class="loading-message">
      <p>Loading proformas...</p>
    </div>

    <div *ngIf="error" class="error-message">
      <p>{{ error }}</p>
      <button mat-raised-button color="primary" (click)="loadProformas()">Retry</button>
    </div>

    <div *ngIf="!loading && !error" class="table-container">
      <!-- Search Filter -->
      <mat-form-field class="filter-field">
        <mat-label>Search proformas</mat-label>
        <input matInput (keyup)="applyFilter($event)" placeholder="Search by proforma number, customer..." #input>
        <mat-icon matSuffix>search</mat-icon>
      </mat-form-field>

      <!-- Proformas Table -->
      <table mat-table [dataSource]="dataSource" matSort class="invoice-table">

        <!-- Proforma Number Column -->
        <ng-container matColumnDef="proformaNumber">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Invoice #</th>
          <td mat-cell *matCellDef="let row">{{ row.proformaNumber || '-' }}</td>
        </ng-container>

        <!-- Proforma Date Column -->
        <ng-container matColumnDef="proformaDate">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Proforma Date</th>
          <td mat-cell *matCellDef="let row">{{ row.proformaDate ? (row.proformaDate | date:'MM/dd/yyyy') : '-' }}</td>
        </ng-container>

        <!-- Due Date Column -->
        <ng-container matColumnDef="dueDate">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Due Date</th>
          <td mat-cell *matCellDef="let row">{{ row.dueDate ? (row.dueDate | date:'MM/dd/yyyy') : '-' }}</td>
        </ng-container>

        <!-- Customer Name Column -->
        <ng-container matColumnDef="customerName">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Customer</th>
          <td mat-cell *matCellDef="let row">{{ row.customerName || '-' }}</td>
        </ng-container>

        <!-- Total Amount Column -->
        <ng-container matColumnDef="totalAmount">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Total Amount</th>
          <td mat-cell *matCellDef="let row">{{ row.totalAmount | currency }}</td>
        </ng-container>

        <!-- Status Column -->
        <ng-container matColumnDef="status">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Status</th>
          <td mat-cell *matCellDef="let row">
            <span class="status-badge"
                  [class.status-paid]="row.status === 'Paid'"
                  [class.status-overdue]="row.status === 'Overdue'"
                  [class.status-pending]="row.status === 'Sent' || row.status === 'PartiallyPaid'">
              {{ row.status || 'Draft' }}
            </span>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;" class="table-row clickable-row" (click)="editProforma(row)"></tr>

        <!-- No Data Row -->
        <tr class="mat-row" *matNoDataRow>
          <td class="mat-cell no-data" [attr.colspan]="displayedColumns.length">
            <div class="no-invoices">
              <mat-icon>description</mat-icon>
              <p *ngIf="!input.value">No proformas found. Click "Create New Proforma" to add your first proforma.</p>
              <p *ngIf="input.value">No proformas match "{{ input.value }}"</p>
            </div>
          </td>
        </tr>
      </table>

      <!-- Paginator -->
      <mat-paginator
        [pageSizeOptions]="[5, 10, 25, 50]"
        [pageSize]="10"
        showFirstLastButtons
        aria-label="Select page of proformas">
      </mat-paginator>
    </div>
  </div>
</div>
